export function handleMessageMultipleChanges(
  object,
  nodes,
  setNodes,
  oldSelectedNode,
) {
  const selectedNode = oldSelectedNode ?? nodes.find((n) => n.selected);
  if (!selectedNode) {
    return;
  }
  setNodes((nds) =>
    nds.map((node) => {
      if (node.id === selectedNode.id) {
        node.data = {
          ...node.data,
          ...object,
        };
      }
      return node;
    }),
  );
}
